export const ACADEMIC_DEGREES_CONFIG = {
    endpoint: 'academic-degrees',
    titleId: 'academic_degrees',
    addTitleId: 'add_academic_degree',
    updateTitleId: 'update_academic_degree',
    searchId: 'search_academic_degrees',
    totalId: 'total_academic_degrees',
    deleteTitleId: 'academic_degree_delete',
    deleteDescId: 'academic_degree_delete_description',
    addedMsgId: 'academic_degree_added_msg',
    updatedMsgId: 'academic_degree_updated_msg',
    deletedMsgId: 'academic_degree_deleted_msg',
    hasActive: true,
};

export const TEACHER_SPECIALIZATIONS_CONFIG = {
    endpoint: 'teacher-specializations',
    titleId: 'teacher_specializations',
    addTitleId: 'add_teacher_specialization',
    updateTitleId: 'update_teacher_specialization',
    searchId: 'search_teacher_specializations',
    totalId: 'total_teacher_specializations',
    deleteTitleId: 'teacher_specialization_delete',
    deleteDescId: 'teacher_specialization_delete_description',
    addedMsgId: 'teacher_specialization_added_msg',
    updatedMsgId: 'teacher_specialization_updated_msg',
    deletedMsgId: 'teacher_specialization_deleted_msg',
    hasActive: true,
};
